<template>
  <list-view class="component-position-selector">
    <div class="component-position"
      v-for="position in componentPositions"
      v-bind:selected="position.index == value"
      v-on:click="positionSelected(position.index)">
      {{ getComponentPositionName(componentType, position.index) }}
    </div>
  </list-view>
</template>

<script>
import listView from 'components/list-view';
import l10n from 'services/l10n-service';

const ComponentPositionNameId = {
  chair_leg: [
    'chair_leg_front_left',
    'chair_leg_front_right',
    'chair_leg_rear_right',
    'chair_leg_rear_left'
  ],
  arm_rest: [
    'arm_rest_left',
    'arm_rest_right'
  ]
};

export default {
  name: 'component-position-selector',
  props: ['componentType', 'componentPositions', 'value'],
  data() {
    return {};
  },
  components: {
    listView
  },
  methods: {
    positionSelected(positionIndex) {
      this.$emit('position-selected', this.componentType, positionIndex);
    },
    getComponentPositionName(componentType, index) {
      if (ComponentPositionNameId[componentType]) {
        return l10n.get(ComponentPositionNameId[componentType][index]);
      } else {
        return '';
      }
    }
  }
};
</script>

<style scoped>
.component-position-selector {
  padding: 10px 15px 20px 15px;
}

.component-position {
  padding: 5px 10px;
  color: black;
  border: 1px solid black;
  margin: 0 5px;
  cursor: pointer;
}

.component-position[selected],
.component-position[selected]:hover {
  color: white;
  background: #6DADAD;
  border: 1px solid #6DADAD;
  font-weight: bold;
}

.component-position:hover {
  background: #F0F0F0;
}
</style>


// WEBPACK FOOTER //
// component-position-selector.vue?a36cb6ee